'use client'

import { useEffect } from 'react'

import { close } from '@/api/bridge/navigation'
import { useNativeEvent, useWebviewNavigation } from '@/hooks'
import { useNavigationStore } from '@/stores/navigationStore'

export default function NativeBackHandler() {
  const { back: webviewBack } = useWebviewNavigation()
  const { canGoBack, init, setDepth } = useNavigationStore()

  // 마운트 시 및 popstate 이벤트 시 depth 복원을 위한 초기화
  useEffect(() => {
    init()

    // 브라우저 뒤로가기 및 popstate 이벤트 호출시에 depth를 복원하기 위한 이벤트 리스너입니다.
    const handlePopState = () => {
      const state = window.history.state
      if (state && typeof state === 'object' && state.fromApp === true && typeof state.depth === 'number') {
        const currentDepth = useNavigationStore.getState().depth

        // 안전장치: back 이동 시에만 복원 (depth가 감소하거나 0인 경우)
        // forward나 잘못된 복원 방지
        if (state.depth <= currentDepth) {
          setDepth(state.depth)
        }
      }
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [init, setDepth])

  useNativeEvent('navigation', 'onNativeBack', async () => {
    try {
      if (canGoBack()) {
        webviewBack()
      } else {
        await close()
      }
    } catch (error) {
      console.error('NativeBackHandler 실패 >> ', error)
    }
  })

  return null
}
